import axios from "axios";

const BaseURL = process.env.VUE_APP_BFFBaseUrl || "https://bff-search-picsv2.fly.dev";

const safebooru = axios.create({
  baseURL: `${BaseURL}/safebooru`,
  timeout: 0,
  // headers: { "X-Custom-Header": "foobar" },
});

const danbooru = axios.create({
  baseURL: `${BaseURL}/danbooru`,
  timeout: 0,
});
const civitAi = axios.create({
  baseURL: `${BaseURL}/civitAi`,
  timeout: 0,
});

const wallheaven = axios.create({
  baseURL: `${BaseURL}/wallheaven`,
  timeout: 0,
});

const wallheavenTags = axios.create({
  baseURL: `${BaseURL}/wallheavenTags`,
  timeout: 0,
});

const yandere = axios.create({
  baseURL: `${BaseURL}/yandere`,
  timeout: 0,
});

const adminLogin = axios.create({
  baseURL: `${BaseURL}/login`,
  timeout: 0,
});

const sendToKawanime = axios.create({
  baseURL: `${BaseURL}/sendToKawanime`,
  timeout: 0,
  // headers: { "X-Custom-Header": "foobar" },
});

export {
  safebooru,
  danbooru,
  civitAi,
  wallheaven,
  wallheavenTags,
  yandere,
  adminLogin,
  sendToKawanime,
};
